import React from 'react';

export const FAQ: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-4xl font-bold mb-6 text-center text-gray-800">Frequently Asked Questions</h1>
      
      <div className="space-y-6">
        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">1. Where is your Shop Located?</h2>
          <p className="text-gray-700 leading-relaxed">
            We are located at Highview Plaza at Thindigua along Kiambu Road.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">2. Do you deliver?</h2>
          <p className="text-gray-700 leading-relaxed">
            We deliver across the country. We have daily doorstep deliveries through our rider within Nairobi 
            and its environs. We deliver to other regions using the courier services we agree on with our customers.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">3. How can I get you?</h2>
          <p className="text-gray-700 leading-relaxed">
            We are accessible through our WhatsApp and call phone number{' '}
            <a href="tel:0759409139" className="text-blue-600 hover:text-blue-800 underline">
              0759409139
            </a>
            . You can also reach us on{' '}
            <a href="mailto:sales.shynerz@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
              sales.shynerz@gmail.com
            </a>
            {' '}for orders or{' '}
            <a href="mailto:shynerz.collections@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
              shynerz.collections@gmail.com
            </a>
            {' '}for any other enquiries.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">Still Have Questions?</h2>
          <p className="text-gray-700 leading-relaxed">
            Contact us at{' '}
            <a href="mailto:shynerz.collections@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
              shynerz.collections@gmail.com
            </a>
            {' '}for any additional questions.
          </p>
        </section>
      </div>
    </div>
  );
}; 